import{createStyles as t}from"../../../../../../theme/utils/create-styles.js";var o=function(){return t({root:{zIndex:2},backdrop:{zIndex:1,position:"fixed",top:0,left:0,right:0,bottom:0}})};export{o as styles};
